import { createFileRoute } from "@tanstack/react-router";

import FreeTrialPage from "@/components/Register/FreeTrialPage";

export const Route = createFileRoute("/free-trial")({
  component: FreeTrialPage,
});
